import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\CreateItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/CreateItemCategoryController.php
* @route '/api/item-category'
*/
const CreateItemCategoryController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateItemCategoryController.url(options),
    method: 'post',
})

CreateItemCategoryController.definition = {
    methods: ["post"],
    url: '/api/item-category',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ItemCategory\CreateItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/CreateItemCategoryController.php
* @route '/api/item-category'
*/
CreateItemCategoryController.url = (options?: RouteQueryOptions) => {
    return CreateItemCategoryController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\CreateItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/CreateItemCategoryController.php
* @route '/api/item-category'
*/
CreateItemCategoryController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateItemCategoryController.url(options),
    method: 'post',
})

export default CreateItemCategoryController